import { useQuery, useMutation, useQueryClient } from 'react-query'
import { getNotifications, markAllNotificationsAsRead, markNotificationAsRead, getPushInterests } from '.'
import { mapNotificationsResponse } from 'pages/notifications/utils/notificationMapper'

export const useNotifications = ({
    page = 1,
    perPage = 20,
    search = '',
    type = 'all',
    isRead,
    enabled = true,
} = {}) =>
    useQuery(
        ['notifications', page, perPage, search, type, isRead],
        () => getNotifications({ page, perPage, search, type, isRead }),
        {
            enabled,
            keepPreviousData: true,
            select: (response) => mapNotificationsResponse(response),
        }
    )

export const useMarkNotificationAsRead = () => {
    const queryClient = useQueryClient()

    return useMutation((notificationId) => markNotificationAsRead(notificationId), {
        onSuccess: () => {
            queryClient.invalidateQueries('notifications')
        },
    })
}

export const useMarkAllNotificationsAsRead = () => {
    const queryClient = useQueryClient()

    return useMutation(() => markAllNotificationsAsRead(), {
        onSuccess: () => {
            queryClient.invalidateQueries('notifications')
        },
    })
}